import { z } from 'zod';

import { DataSourceApiKey } from '../../document/template.js';
import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export enum GenerateDocumentMode {
  DocumentTemplate = 'DocumentTemplate',
  Markdown = 'Markdown',
  CombinePdf = 'CombinePdf',
}

// Generate the schema dynamically
export const DocumentTemplateBlockConfigSchema = z.discriminatedUnion('generateDocumentMode', [
  z.object({
    generateDocumentMode: z.literal(GenerateDocumentMode.DocumentTemplate),
    documentTemplateId: z.uuid(),
    valuesByDocumentTemplateKey: z.partialRecord(z.enum(DataSourceApiKey), z.string().optional()),
    returnType: returnTypeSchema(ProducedType.FileReference),
  }),
  z.object({
    generateDocumentMode: z.literal(GenerateDocumentMode.Markdown),
    markdown: z.string(),
    returnType: returnTypeSchema(ProducedType.FileReference),
  }),
  z.object({
    generateDocumentMode: z.literal(GenerateDocumentMode.CombinePdf),
    fileReferences: z.string(),
    returnType: returnTypeSchema(ProducedType.FileReference),
  }),
]);

export type DocumentTemplateBlockConfig = z.infer<typeof DocumentTemplateBlockConfigSchema>;

export const DocumentTemplateBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.DocumentTemplate),
  config: DocumentTemplateBlockConfigSchema,
});

export type DocumentTemplateBlock = z.infer<typeof DocumentTemplateBlockSchema>;
